import { render } from "./TileGroup.vue?vue&type=template&id=2ba93326"
import script from "./TileGroup.vue?vue&type=script&lang=js"
export * from "./TileGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QItemLabel});
